import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { FormBox, InputBox } from '../../../components/AntdAddons';
import LoginBanner from '../../../assets/images/login-banner-2.gif';
import { Link, useNavigate } from 'react-router-dom';
import { assignErrorToInput } from '../../../store/api';
import { LoginRequest } from './Validation';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '../../../store/AuthSlice';
import Logo from '../../../assets/images/logo.svg';

const ForgotPassword: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSubmit = (data: any) => {
    setSaving(true);
    dispatch(forgotPassword(data))
      .then(() => {
        form.resetFields();
        navigate('/login');
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      })
      .finally(() => setSaving(false));
  };

  return (
    <section className="loginSection forgotPassword">
      <div className="loginWrap">
        <div className="loginForm">
          <div className="loginFormWrap">
            <img
              src={Logo}
              alt="logo"
              className="logo"
            />
            <div className="formTitle">
              <h2 className="title">Forgot Password</h2>
            </div>
            <FormBox
              form={form}
              onFinish={handleSubmit}
            >
              <InputBox.Text
                name="username"
                label={'Username'}
                placeholder="username"
                required
                rules={LoginRequest().user('User Name')}
              />
              <div className="text-center">
                <Button
                  loading={saving}
                  type="primary"
                  htmlType="submit"
                  className="activeBtn"
                >
                  Forgot Password
                </Button>
              </div>
              <div className="text-right mt-10 font-medium text-white">
                <Link to="/login">Back to login</Link>
              </div>
            </FormBox>
          </div>
        </div>

        <img
          src={LoginBanner}
          alt=""
          className="LoginBanner"
        />
      </div>
    </section>
  );
};

export default ForgotPassword;
